const UPDATES = [
  { title: '《暗夜猎魔人：觉醒》第156话更新', time: '10分钟前', type: 'update', tag: '国漫' },
  { title: '《霸道总裁的契约新娘》第89话更新', time: '25分钟前', type: 'update', tag: '韩漫' },
  { title: '《狐妖大人请留步》第203话更新', time: '1小时前', type: 'update', tag: '国漫' },
  { title: '《深海迷踪：深渊之眼》第34话更新', time: '2小时前', type: 'update', tag: '日漫' },
  { title: '《秘密花园的秘密》第78话更新', time: '3小时前', type: 'update', tag: '韩漫' },
  { title: '新作《星际流浪者》正式上线', time: '4小时前', type: 'new', tag: '日漫' },
  { title: '《重生之商业帝国》第67话更新', time: '5小时前', type: 'update', tag: '韩漫' },
  { title: '《青梅竹马是吸血鬼》番外篇上线', time: '昨天', type: 'extra', tag: '日漫' },
  { title: '本周热门专题「夏日恋爱特辑」上线', time: '昨天', type: 'feature', tag: '专题' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            最近更新
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时追踪<strong>免费漫画</strong>更新动态，不错过任何精彩章节
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200 space-y-0">
            {UPDATES.map((item, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className={`absolute -left-[25px] w-3 h-3 rounded-full border-2 border-background-50 ${
                  item.type === 'new'
                    ? 'bg-accent-500'
                    : item.type === 'extra'
                    ? 'bg-secondary-500'
                    : item.type === 'feature'
                    ? 'bg-accent-500'
                    : 'bg-primary-500'
                }`}></div>
                <a
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block bg-background-100 hover:bg-background-200 rounded-xl p-4 md:p-5 transition-colors duration-200 cursor-pointer"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap mb-1">
                        <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full ${
                          item.type === 'new'
                            ? 'bg-accent-100 text-accent-700'
                            : item.type === 'extra'
                            ? 'bg-secondary-100 text-secondary-700'
                            : item.type === 'feature'
                            ? 'bg-accent-100 text-accent-700'
                            : 'bg-primary-100 text-primary-700'
                        }`}>
                          {item.type === 'new' ? '新作' : item.type === 'extra' ? '番外' : item.type === 'feature' ? '专题' : '更新'}
                        </span>
                        <span className="px-2 py-0.5 text-[10px] bg-background-200 text-foreground-600 rounded-full">
                          {item.tag}
                        </span>
                      </div>
                      <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1">
                        {item.title}
                      </h3>
                    </div>
                    <span className="text-xs text-foreground-500 whitespace-nowrap mt-1">{item.time}</span>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}